import { ApplicationServiceData } from 'services/GameHosting/Application/applicationServiceType';
import { ApplicationBuildServiceData } from 'services/GameHosting/ApplicationBuild/applicationBuildServiceType';
import { DeploymentEnvironmentServiceData } from 'services/GameHosting/DeploymentEnv/deploymentEnvironmentServiceType';
import { SortParams } from 'types/common/sorting';
import { FleetServiceData } from 'types/GameHosting/fleet';
import { FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_DEPLOYMENT_ENVIRONMENT = 'FETCH_DEPLOYMENT_ENVIRONMENT';

export const FETCH_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'FETCH_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const FETCH_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'FETCH_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const ADD_DEPLOYMENT_ENVIRONMENT = 'ADD_DEPLOYMENT_ENVIRONMENT';

export const ADD_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'ADD_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const ADD_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'ADD_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const UPDATE_DEPLOYMENT_ENVIRONMENT = 'UPDATE_DEPLOYMENT_ENVIRONMENT';

export const UPDATE_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'UPDATE_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const UPDATE_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'UPDATE_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const REMOVE_DEPLOYMENT_ENVIRONMENT = 'REMOVE_DEPLOYMENT_ENVIRONMENT';

export const REMOVE_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'REMOVE_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const REMOVE_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'REMOVE_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT = 'FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT';

export const FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT = 'FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT';

export const FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT = 'FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT';

export const FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const SELECT_DEPLOYMENT_ENVIRONMENT = 'SELECT_DEPLOYMENT_ENVIRONMENT';

export const CANCEL_EDITION = 'CANCEL_EDITION_DEPLOYMENT_ENVIRONMENT';

export const SORT = 'SORT_DEPLOYMENT_ENVIRONMENTS';

export const CLEAN_ERROR = 'CLEAR_ERROR_DEPLOYMENT_ENVIRONMENT';

export type DeploymentEnvironmentReducerState = FetchReducer<
  'fetch' | 'add' | 'edit' | 'delete' | 'fetchApplication' | 'fetchApplicationBuild' | 'fetchFleet'
> & {
  depEnv: DeploymentEnvironmentServiceData[];
  selectedDeploymentEnvironmentId: null | string;
  application: ApplicationServiceData[];
  applicationBuild: ApplicationBuildServiceData[];
  fleet: FleetServiceData[];
} & SortState<DeploymentEnvironmentServiceData>;

export type DeploymentEnvironmentActions =
  | FetchAction<'FETCH_DEPLOYMENT_ENVIRONMENT', DeploymentEnvironmentServiceData[]>
  | FetchAction<'ADD_DEPLOYMENT_ENVIRONMENT', DeploymentEnvironmentServiceData>
  | FetchAction<'UPDATE_DEPLOYMENT_ENVIRONMENT', DeploymentEnvironmentServiceData>
  | FetchAction<'REMOVE_DEPLOYMENT_ENVIRONMENT', DeploymentEnvironmentServiceData>
  | FetchAction<'FETCH_APPLICATION_BY_DEPLOYMENT_ENVIRONMENT', ApplicationServiceData[]>
  | FetchAction<'FETCH_APPLICATION_BUILD_BY_DEPLOYMENT_ENVIRONMENT', ApplicationBuildServiceData[]>
  | FetchAction<'FETCH_FLEETS_BY_APPLICATION_AND_DEPLOYMENT_ENVIRONMENT', FleetServiceData[]>
  | { type: 'SELECT_DEPLOYMENT_ENVIRONMENT'; depEnvId: string | null }
  | { type: 'CANCEL_EDITION_DEPLOYMENT_ENVIRONMENT' }
  | { type: 'SORT_DEPLOYMENT_ENVIRONMENTS'; params: SortParams<DeploymentEnvironmentServiceData> }
  | { type: 'CLEAR_ERROR_DEPLOYMENT_ENVIRONMENT' }
  | { type: 'RESET_DEPLOYMENT_ENV_REDUCER' }
  | ResetReducerAction;
